module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "wrapper"
    }
  }, [_c('app-header'), _vm._v(" "), (_vm.userHasResearcherRole()) ? _c('researcher-sidebar') : _vm._e(), _vm._v(" "), (_vm.userHasAdminRole()) ? _c('admin-sidebar') : _vm._e(), _vm._v(" "), (_vm.userHasParkRole()) ? _c('park-sidebar') : _vm._e(), _vm._v(" "), (_vm.userHasPartnerRole()) ? _c('partner-sidebar') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ac6ea9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Adminlte.vue
// module id = 678
// module chunks = 1